module.exports = __webpack_public_path__ + "static/sep-dee106ba6241b1e7e71ced3f628cd128.svg";